export default "__VITE_ASSET__Cgb4_0uY__"